import { render, staticRenderFns } from "./reward-item.vue?vue&type=template&id=197b6491"
import script from "./reward-item.vue?vue&type=script&lang=js"
export * from "./reward-item.vue?vue&type=script&lang=js"
import style0 from "./reward-item.vue?vue&type=style&index=0&id=197b6491&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports